import React, { lazy, Suspense, useLayoutEffect, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Testimonial from "../Testimonial/Testimonial";

// Lazy imports
const Homepage = lazy(() => import("../HomePage"));
const AboutPage = lazy(() => import("../AboutPage/AboutPage"));
const SeviceSinglePage = lazy(() => import("../SeviceSinglePage"));
const TeamSinglePage = lazy(() => import("../TeamSinglePage/TeamSinglePage"));
const ProjectSinglePage = lazy(() => import("../ProjectSinglePage/ProjectSinglePage"));
const ProductSinglePage = lazy(() => import("../ProductSinglePage"));
const PortfolioGridPage = lazy(() => import("../PortfolioGridPage/PortfolioGridPage"));
const PortfolioMasonaryPage = lazy(() => import("../PortfolioMasonaryPage/PortfolioMasonaryPage"));
const PortfolioMasonaryPageS2 = lazy(() => import("../PortfolioMasonaryPageS2/PortfolioMasonaryPageS2"));
const PortfolioMasonaryPageS3 = lazy(() => import("../PortfolioMasonaryPageS3/PortfolioMasonaryPageS3"));
const PortfolioMasonaryPageS4 = lazy(() => import("../PortfolioMasonaryPageS4/PortfolioMasonaryPageS4"));
const InquiryPage = lazy(() => import("../InquiryPage/InquiryPage"));
const Inquiry1Page = lazy(() => import("../Inquiry1Page/Inquiry1Page"));
const LoginPage = lazy(() => import("../LoginPage"));
const SignUpPage = lazy(() => import("../SignUpPage"));
const ForgotPassword = lazy(() => import("../ForgotPassword"));
const GalleryPage = lazy(() => import("../GalleryPage/GalleryPage"));
const PlannerPage = lazy(() => import("../PlannerPage/PlannerPage"));
const BrideGroomsPage = lazy(() => import("../BrideGroomsPage/BrideGroomsPage"));
const ServicePage = lazy(() => import("../ServicePage/ServicePage"));
const ServicePageS2 = lazy(() => import("../ServicePageS2/ServicePageS2"));
const ServicePageS3 = lazy(() => import("../ServicePageS3/ServicePageS3"));
const PricingPage = lazy(() => import("../PricingPage/PricingPage"));
const ComingSoonPage = lazy(() => import("../ComingSoonPage/ComingSoonPage"));
const ErrorPage = lazy(() => import("../ErrorPage/ErrorPage"));
const Photography = lazy(() => import("../photography/Photography"));
const Films = lazy(() => import("../Films/Films"));
const CareerstPage = lazy(() => import("../Careers/Careers"));
const Travel = lazy(() => import("../Travel/Travel"));
const Backyard = lazy(() => import("../Backyard/Backyard"));
const FilmProjectSinglepage = lazy(() => import("../ProjectSinglePage/FilmProjectSinglepage"));
const Editorial = lazy(() => import("../Editorial/Editorial"));
const WeddingView = lazy(() => import("../Weddingview/WeddingView"));
const Albums = lazy(() => import("../albums/albums"));
const DownloadZip = lazy(() => import("../DownloadZip/DownloadZip"));
const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

// Fires Meta Pixel custom event 'Scroll_75' once per page visit at 75% scroll depth
const ScrollDepthTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let scrollTracked = false;

    const onScroll = () => {
      if (scrollTracked) return;
      const scrollable =
        document.documentElement.scrollHeight - window.innerHeight;
      if (!(scrollable > 0)) return;
      const scrollPercent = (window.scrollY / scrollable) * 100;
      if (scrollPercent >= 75) {
        if (typeof window.fbq === "function") {
          window.fbq("trackCustom", "Scroll_75");
        }
        scrollTracked = true;
        window.removeEventListener("scroll", onScroll);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  return null;
};
const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
      <ScrollDepthTracker />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="portfolio-photo" element={<Photography />} />
            <Route path="travel" element={<Travel />} />
            <Route path="Editorial" element={<Editorial />} />
            <Route path="backyard" element={<Backyard />} />
            <Route path="view/:id" element={<WeddingView />} />
            <Route path="albums/:id" element={<Albums />} />
            <Route path="download-zip" element={<DownloadZip />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="hotc-films" element={<Films />} />

            <Route path="portfolio-photo-single/:id" element={<ProjectSinglePage />} />
            <Route path="portfolio-film-single/:id" element={<FilmProjectSinglepage />} />
            <Route path="/product-single/:id" element={<ProductSinglePage />} />

            <Route path="/Inquiry" element={<InquiryPage />} />
            <Route path="/inquiry1" element={<Inquiry1Page />} />
            <Route path="/Careers" element={<CareerstPage />} />
            <Route path="/Testimonial" element={<Testimonial />} />
            <Route path="/404" element={<ErrorPage />} />

            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
